<template>
  <svg
    width="210"
    height="137"
    viewBox="0 0 210 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#9333EA"
    />
    <rect
      x="22"
      y="8"
      width="24"
      height="24"
      rx="2"
      fill="#F4F0FA"
    />
    <path
      d="M34.7328 15.2686L34.9339 15.4697L34.9339 15.4697L34.7328 15.2686ZM35.2694 15.2693L35.0682 15.4704L35.0683 15.4704L35.2694 15.2693ZM36.1539 16.1539L36.3913 16.3105L36.519 16.1168L36.355 15.9528L36.1539 16.1539ZM36.3266 17.6662L36.1255 17.8672L36.1255 17.8673L36.3266 17.6662ZM37.8375 17.8374L38.0385 17.6363L37.8746 17.4723L37.6809 17.6L37.8375 17.8374ZM38.7324 18.7323L38.9336 18.5314L38.9335 18.5313L38.7324 18.7323ZM38.7317 19.2689L38.9328 19.47L38.9328 19.47L38.7317 19.2689ZM33.2682 24.731L33.0671 24.5299L33.0671 24.5299L33.2682 24.731ZM32.7316 24.7317L32.5304 24.9326L32.5307 24.9329L32.7316 24.7317ZM32.0004 23.999L32.2016 23.7982L32.2015 23.798L32.0004 23.999ZM31.8367 23.8354L31.5975 23.6816L31.4735 23.8744L31.6356 24.0365L31.8367 23.8354ZM31.6579 22.3349L31.859 22.1338L31.859 22.1338L31.6579 22.3349ZM30.156 22.1546L29.9549 22.3557L30.117 22.5179L30.3098 22.3938L30.156 22.1546ZM29.2693 21.268L29.0682 21.469L29.0682 21.4691L29.2693 21.268ZM29.2693 20.7308L29.0682 20.5296L29.0682 20.5296L29.2693 20.7308ZM34.7328 15.2686L34.9339 15.4697C34.9703 15.4333 35.0306 15.4328 35.0682 15.4704L35.2694 15.2693L35.4705 15.0683C35.212 14.8097 34.7915 14.8078 34.5318 15.0675L34.7328 15.2686ZM35.2694 15.2693L35.0683 15.4704L35.9528 16.355L36.1539 16.1539L36.355 15.9528L35.4704 15.0682L35.2694 15.2693ZM36.1539 16.1539L35.9165 15.9973C35.5367 16.5731 35.6158 17.3575 36.1255 17.8672L36.3266 17.6662L36.5277 17.4651C36.2043 17.1417 36.1638 16.6554 36.3913 16.3105L36.1539 16.1539ZM36.3266 17.6662L36.1255 17.8673C36.6356 18.3771 37.4187 18.4541 37.994 18.0748L37.8375 17.8374L37.6809 17.6C37.3356 17.8277 36.8505 17.7878 36.5276 17.465L36.3266 17.6662ZM37.8375 17.8374L37.6364 18.0385L38.5313 18.9334L38.7324 18.7323L38.9335 18.5313L38.0385 17.6363L37.8375 17.8374ZM38.7324 18.7323L38.5312 18.9333C38.5677 18.9699 38.5681 19.0303 38.5306 19.0678L38.7317 19.2689L38.9328 19.47C39.1914 19.2115 39.193 18.7911 38.9336 18.5314L38.7324 18.7323ZM38.7317 19.2689L38.5306 19.0678L33.0671 24.5299L33.2682 24.731L33.4693 24.9321L38.9328 19.47L38.7317 19.2689ZM33.2682 24.731L33.0671 24.5299C33.0295 24.5675 32.9691 24.5669 32.9326 24.5305L32.7316 24.7317L32.5307 24.9329C32.7904 25.1923 33.2108 25.1905 33.4693 24.9321L33.2682 24.731ZM32.7316 24.7317L32.9329 24.5308L32.2016 23.7982L32.0004 23.999L31.7991 24.1999L32.5304 24.9326L32.7316 24.7317ZM32.0004 23.999L32.2015 23.798L32.0378 23.6343L31.8367 23.8354L31.6356 24.0365L31.7993 24.2001L32.0004 23.999ZM31.8367 23.8354L32.0759 23.9892C32.4452 23.4151 32.3647 22.6397 31.859 22.1338L31.6579 22.3349L31.4567 22.5359C31.7771 22.8564 31.8192 23.337 31.5975 23.6816L31.8367 23.8354ZM31.6579 22.3349L31.859 22.1338C31.3533 21.6282 30.5768 21.5457 30.0021 21.9155L30.156 22.1546L30.3098 22.3938C30.6541 22.1723 31.1358 22.215 31.4568 22.5359L31.6579 22.3349ZM30.156 22.1546L30.357 21.9535L29.4704 21.0669L29.2693 21.268L29.0682 21.4691L29.9549 22.3557L30.156 22.1546ZM29.2693 21.268L29.4704 21.0669C29.4333 21.0298 29.4334 20.9688 29.4704 20.9319L29.2693 20.7308L29.0682 20.5296C28.809 20.7888 28.8092 21.2099 29.0682 21.469L29.2693 21.268ZM29.2693 20.7308L29.4704 20.9319L34.9339 15.4697L34.7328 15.2686L34.5318 15.0675L29.0682 20.5296L29.2693 20.7308Z"
      fill="#222222"
    />
    <rect
      x="54"
      y="10"
      width="104"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="54"
      y="22"
      width="52"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M22 59.0334C22 57.3581 23.3581 56 25.0334 56H42.9666C44.6419 56 46 57.3581 46 59.0334V76.9666C46 78.6419 44.6419 80 42.9666 80H25.0334C23.3581 80 22 78.6419 22 76.9666V59.0334Z"
      fill="#F5F5F4"
    />
    <path
      d="M34.7328 63.2686L34.9339 63.4697L34.9339 63.4697L34.7328 63.2686ZM35.2694 63.2693L35.0682 63.4704L35.0683 63.4704L35.2694 63.2693ZM36.1539 64.1539L36.3913 64.3105L36.519 64.1168L36.355 63.9528L36.1539 64.1539ZM36.3266 65.6662L36.1255 65.8672L36.1255 65.8673L36.3266 65.6662ZM37.8375 65.8374L38.0385 65.6363L37.8746 65.4723L37.6809 65.6L37.8375 65.8374ZM38.7324 66.7323L38.9336 66.5314L38.9335 66.5313L38.7324 66.7323ZM38.7317 67.2689L38.9328 67.47L38.9328 67.47L38.7317 67.2689ZM33.2682 72.731L33.0671 72.5299L33.0671 72.5299L33.2682 72.731ZM32.7316 72.7317L32.5304 72.9326L32.5307 72.9329L32.7316 72.7317ZM32.0004 71.999L32.2016 71.7982L32.2015 71.798L32.0004 71.999ZM31.8367 71.8354L31.5975 71.6816L31.4735 71.8744L31.6356 72.0365L31.8367 71.8354ZM31.6579 70.3349L31.859 70.1338L31.859 70.1338L31.6579 70.3349ZM30.156 70.1546L29.9549 70.3557L30.117 70.5179L30.3098 70.3938L30.156 70.1546ZM29.2693 69.268L29.0682 69.469L29.0682 69.4691L29.2693 69.268ZM29.2693 68.7308L29.0682 68.5296L29.0682 68.5296L29.2693 68.7308ZM34.7328 63.2686L34.9339 63.4697C34.9703 63.4333 35.0306 63.4328 35.0682 63.4704L35.2694 63.2693L35.4705 63.0683C35.212 62.8097 34.7915 62.8078 34.5318 63.0675L34.7328 63.2686ZM35.2694 63.2693L35.0683 63.4704L35.9528 64.355L36.1539 64.1539L36.355 63.9528L35.4704 63.0682L35.2694 63.2693ZM36.1539 64.1539L35.9165 63.9973C35.5367 64.5731 35.6158 65.3575 36.1255 65.8672L36.3266 65.6662L36.5277 65.4651C36.2043 65.1417 36.1638 64.6554 36.3913 64.3105L36.1539 64.1539ZM36.3266 65.6662L36.1255 65.8673C36.6356 66.3771 37.4187 66.4541 37.994 66.0748L37.8375 65.8374L37.6809 65.6C37.3356 65.8277 36.8505 65.7878 36.5276 65.465L36.3266 65.6662ZM37.8375 65.8374L37.6364 66.0385L38.5313 66.9334L38.7324 66.7323L38.9335 66.5313L38.0385 65.6363L37.8375 65.8374ZM38.7324 66.7323L38.5312 66.9333C38.5677 66.9699 38.5681 67.0303 38.5306 67.0678L38.7317 67.2689L38.9328 67.47C39.1914 67.2115 39.193 66.7911 38.9336 66.5314L38.7324 66.7323ZM38.7317 67.2689L38.5306 67.0678L33.0671 72.5299L33.2682 72.731L33.4693 72.9321L38.9328 67.47L38.7317 67.2689ZM33.2682 72.731L33.0671 72.5299C33.0295 72.5675 32.9691 72.5669 32.9326 72.5305L32.7316 72.7317L32.5307 72.9329C32.7904 73.1923 33.2108 73.1905 33.4693 72.9321L33.2682 72.731ZM32.7316 72.7317L32.9329 72.5308L32.2016 71.7982L32.0004 71.999L31.7991 72.1999L32.5304 72.9326L32.7316 72.7317ZM32.0004 71.999L32.2015 71.798L32.0378 71.6343L31.8367 71.8354L31.6356 72.0365L31.7993 72.2001L32.0004 71.999ZM31.8367 71.8354L32.0759 71.9892C32.4452 71.4151 32.3647 70.6397 31.859 70.1338L31.6579 70.3349L31.4567 70.5359C31.7771 70.8564 31.8192 71.337 31.5975 71.6816L31.8367 71.8354ZM31.6579 70.3349L31.859 70.1338C31.3533 69.6282 30.5768 69.5457 30.0021 69.9155L30.156 70.1546L30.3098 70.3938C30.6541 70.1723 31.1358 70.215 31.4568 70.5359L31.6579 70.3349ZM30.156 70.1546L30.357 69.9535L29.4704 69.0669L29.2693 69.268L29.0682 69.4691L29.9549 70.3557L30.156 70.1546ZM29.2693 69.268L29.4704 69.0669C29.4333 69.0298 29.4334 68.9688 29.4704 68.9319L29.2693 68.7308L29.0682 68.5296C28.809 68.7888 28.8092 69.2099 29.0682 69.469L29.2693 69.268ZM29.2693 68.7308L29.4704 68.9319L34.9339 63.4697L34.7328 63.2686L34.5318 63.0675L29.0682 68.5296L29.2693 68.7308Z"
      fill="#222222"
    />
    <rect
      x="54"
      y="58"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="70"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M22 107.033C22 105.358 23.3581 104 25.0334 104H42.9666C44.6419 104 46 105.358 46 107.033V124.967C46 126.642 44.6419 128 42.9666 128H25.0334C23.3581 128 22 126.642 22 124.967V107.033Z"
      fill="#F5F5F4"
    />
    <path
      d="M34.7328 111.269L34.9339 111.47L34.9339 111.47L34.7328 111.269ZM35.2694 111.269L35.0682 111.47L35.0683 111.47L35.2694 111.269ZM36.1539 112.154L36.3913 112.31L36.519 112.117L36.355 111.953L36.1539 112.154ZM36.3266 113.666L36.1255 113.867L36.1255 113.867L36.3266 113.666ZM37.8375 113.837L38.0385 113.636L37.8746 113.472L37.6809 113.6L37.8375 113.837ZM38.7324 114.732L38.9336 114.531L38.9335 114.531L38.7324 114.732ZM38.7317 115.269L38.9328 115.47L38.9328 115.47L38.7317 115.269ZM33.2682 120.731L33.0671 120.53L33.0671 120.53L33.2682 120.731ZM32.7316 120.732L32.5304 120.933L32.5307 120.933L32.7316 120.732ZM32.0004 119.999L32.2016 119.798L32.2015 119.798L32.0004 119.999ZM31.8367 119.835L31.5975 119.682L31.4735 119.874L31.6356 120.036L31.8367 119.835ZM31.6579 118.335L31.859 118.134L31.859 118.134L31.6579 118.335ZM30.156 118.155L29.9549 118.356L30.117 118.518L30.3098 118.394L30.156 118.155ZM29.2693 117.268L29.0682 117.469L29.0682 117.469L29.2693 117.268ZM29.2693 116.731L29.0682 116.53L29.0682 116.53L29.2693 116.731ZM34.7328 111.269L34.9339 111.47C34.9703 111.433 35.0306 111.433 35.0682 111.47L35.2694 111.269L35.4705 111.068C35.212 110.81 34.7915 110.808 34.5318 111.068L34.7328 111.269ZM35.2694 111.269L35.0683 111.47L35.9528 112.355L36.1539 112.154L36.355 111.953L35.4704 111.068L35.2694 111.269ZM36.1539 112.154L35.9165 111.997C35.5367 112.573 35.6158 113.358 36.1255 113.867L36.3266 113.666L36.5277 113.465C36.2043 113.142 36.1638 112.655 36.3913 112.31L36.1539 112.154ZM36.3266 113.666L36.1255 113.867C36.6356 114.377 37.4187 114.454 37.994 114.075L37.8375 113.837L37.6809 113.6C37.3356 113.828 36.8505 113.788 36.5276 113.465L36.3266 113.666ZM37.8375 113.837L37.6364 114.039L38.5313 114.933L38.7324 114.732L38.9335 114.531L38.0385 113.636L37.8375 113.837ZM38.7324 114.732L38.5312 114.933C38.5677 114.97 38.5681 115.03 38.5306 115.068L38.7317 115.269L38.9328 115.47C39.1914 115.211 39.193 114.791 38.9336 114.531L38.7324 114.732ZM38.7317 115.269L38.5306 115.068L33.0671 120.53L33.2682 120.731L33.4693 120.932L38.9328 115.47L38.7317 115.269ZM33.2682 120.731L33.0671 120.53C33.0295 120.567 32.9691 120.567 32.9326 120.531L32.7316 120.732L32.5307 120.933C32.7904 121.192 33.2108 121.191 33.4693 120.932L33.2682 120.731ZM32.7316 120.732L32.9329 120.531L32.2016 119.798L32.0004 119.999L31.7991 120.2L32.5304 120.933L32.7316 120.732ZM32.0004 119.999L32.2015 119.798L32.0378 119.634L31.8367 119.835L31.6356 120.036L31.7993 120.2L32.0004 119.999ZM31.8367 119.835L32.0759 119.989C32.4452 119.415 32.3647 118.64 31.859 118.134L31.6579 118.335L31.4567 118.536C31.7771 118.856 31.8192 119.337 31.5975 119.682L31.8367 119.835ZM31.6579 118.335L31.859 118.134C31.3533 117.628 30.5768 117.546 30.0021 117.915L30.156 118.155L30.3098 118.394C30.6541 118.172 31.1358 118.215 31.4568 118.536L31.6579 118.335ZM30.156 118.155L30.357 117.954L29.4704 117.067L29.2693 117.268L29.0682 117.469L29.9549 118.356L30.156 118.155ZM29.2693 117.268L29.4704 117.067C29.4333 117.03 29.4334 116.969 29.4704 116.932L29.2693 116.731L29.0682 116.53C28.809 116.789 28.8092 117.21 29.0682 117.469L29.2693 117.268ZM29.2693 116.731L29.4704 116.932L34.9339 111.47L34.7328 111.269L34.5318 111.068L29.0682 116.53L29.2693 116.731Z"
      fill="#222222"
    />
    <rect
      x="54"
      y="106"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="118"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      y="49"
      width="210"
      height="88"
      fill="url(#paint0_linear_3534_24544)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3534_24544"
        x1="105"
        y1="49"
        x2="105"
        y2="137"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="white"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>
